import Heading from "@core/components/title/Heading";
import LoginLink from "@core/layouts/header/components/common/LoginLink";
import { ChevronRight } from "lucide-react";

export default function NcfzToPlayncLogin() {
  return (
    <div className="flex h-full flex-col items-center justify-center text-center max-lg:pb-[30px]">
      <Heading level={1} className="text-[15px] font-normal">
        PLAYNC 계정으로 전환된 계정입니다. <br />
        PLAYNC 아이디로 로그인해주세요.
      </Heading>
      <LoginLink variant="borderPoint200" size="large" className="mt-[60px]">
        PLAYNC 로그인
        <ChevronRight className="ml-[8px] size-4" />
      </LoginLink>
    </div>
  );
}
